module.exports = __webpack_public_path__ + "media/V70.3baa1d35.mp4";